import { create } from "zustand";

/**
 * Whether the device store opened, for the field layout. Kept apart from
 * runtime.ts so the layout (in the main bundle) doesn't pull in Dexie and
 * the sync code; the runtime writes here, the layout reads.
 */
export interface FieldStorageStatus {
  /** False when IndexedDB is unavailable and work lives only in this tab. */
  durable: boolean;
  /**
   * Set when IndexedDB is there but wouldn't open after retries (for example
   * iOS "Connection to Indexed Database server lost"). The field screens
   * block on it rather than capture into memory that a reload would lose.
   */
  problem: string | null;
  /** Bumps on "Try again", so screens open the runtime again. */
  attempt: number;
}

export const useFieldStorage = create<FieldStorageStatus>(() => ({
  durable: true,
  problem: null,
  attempt: 0,
}));

/** "Try again" after a storage problem: the next runtime open retries from scratch. */
export function retryFieldStorage(): void {
  useFieldStorage.setState((s) => ({ problem: null, attempt: s.attempt + 1 }));
}
